import { apiClient, type ApiResponse } from '@/api';
import { NOTIFICATION_API_URLS } from '@/api/constants/api.url';
import type { ListNotificationsParams, NotificationListResponse } from '@/modules/notifications/types';

export const notificationsService = {
    /** Fetch notifications + the unread count (used by both bell and page). */
    async list(params: ListNotificationsParams = {}): Promise<NotificationListResponse> {
        const { data } = await apiClient.get<ApiResponse<NotificationListResponse>>(
            NOTIFICATION_API_URLS.list,
            {
                params: {
                    limit:  params.limit ?? 30,
                    ...(params.unread ? { unread: 'true' } : {}),
                },
            },
        );
        return data.data;
    },
    async markRead(id: string): Promise<void> {
        await apiClient.post(NOTIFICATION_API_URLS.markRead(id));
    },
    async markAllRead(): Promise<void> {
        await apiClient.post(NOTIFICATION_API_URLS.markAllRead);
    },
};
